export const bufferToBase64 = async (buffer: Uint8Array) => {
    // use a FileReader to generate a base64 data URI:
    const base64url = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.readAsDataURL(new Blob([buffer]));
    });

    // remove the `data:...;base64,` part from the start
    return base64url.slice(base64url.indexOf(',') + 1);
};
